import { Component, ChangeDetectionStrategy } from '@angular/core';

import {
  ICloseReturnType,
  PlaceholderChildComponent
} from '@ispm/layout/classes/placeholder-child-component.abstract';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';

@Component({
  selector: 'gen-user-merge-notification-modal',
  template: `
    <span>&nbsp;</span>
    `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMergeNotificationModalComponent extends PlaceholderChildComponent {
  beforeClose(_modalResponse?: modalResponse): void | ICloseReturnType {
    return undefined;
  }

}
